import header from './header.json'
import sidebar from './sidebar.json'
import popover from './popover.json'
import select from './select.json'
import table from './table.json'
import logList from './logList.json'
import dialog from './dialog.json'
import input from './input.json'
import loading from './loading.json'
import datePicker from './datePicker.json'
import notification from './notification.json'

export default {
  en: {
    header: header.en,
    sidebar: sidebar.en,
    popover: popover.en,
    select: select.en,
    table: table.en,
    logList: logList.en,
    dialog: dialog.en,
    input: input.en,
    loading: loading.en,
    datePicker: datePicker.en,
    notification: notification.en
  },
  ru: {
    header: header.ru,
    sidebar: sidebar.ru,
    popover: popover.ru,
    select: select.ru,
    table: table.ru,
    logList: logList.ru,
    dialog: dialog.ru,
    input: input.ru,
    loading: loading.ru,
    datePicker: datePicker.ru,
    notification: notification.ru
  }
}
